import { render } from "./index.vue?vue&type=template&id=67c279b8"
import script from "./footer.ts?vue&type=script&lang=js"
export * from "./footer.ts?vue&type=script&lang=js"

import "./footer.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script